import { Button} from "@mui/material";
import styled  from "styled-components";

export const BtnContainer = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
    justify-content: flex-end;
    margin-top: 20px;
    padding-bottom: 10px;
    padding-right: 20px;
`;

export const ButtonPrimary = styled.button<any>`
    background-color: ${p => p.theme.btn?.primary.background};
    font-size: 1rem !important;
    color: white;
    padding: 8px 30px;
    margin: 10px;
    border: none;
    border-radius: 5px;
    min-width: 100px;
    transition: box-shadow 0.2s ease-in-out;

    &:hover {
        background-color: rgb(${p => p.theme.btn?.primary.background} / 1)  !important;
        box-shadow: 0px 0px 6px 1px rgba(110,110,110,1);
    }
`;

export const ButtonSecondary = styled.button<any>`
    font-size: 1rem !important;
    color: ${p => p.theme.btn?.primary.background};
    padding: 8px 30px;
    margin: 10px;
    border: solid 0.5px;
    border-color: ${p => p.theme.btn?.secondary.background};
    border-radius: 5px;
    min-width: 100px;
    transition: box-shadow 0.2s ease-in-out;

    &:hover {
        background-color: rgb(${p => p.theme.btn?.primary.background} / 1)  !important;
        box-shadow: 0px 0px 6px 1px rgba(110,110,110,1);
    }

`;